import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';
import { Button } from '../../../../../components';

const cx = classNames.bind(styles);

const SubmitButton = props => {
  const {
    buttonAction,
    buttonDisabled,
    buttonLabel,
    updatingLabel,
    updating,
    totalCents,
    activityName,
    dropInId,
    currentUserId,
    organizationName,
    addedVoloPass,
  } = props;

  return (
    <div className={cx('submitButton', 'mt-1 pt-1 small')}>
      <Button
        primary
        square
        onClick={() => buttonAction()}
        disabled={buttonDisabled}
        className={cx('button')}
        attrs={{
          'data-program-type': 'DAILY',
          'data-registrant-type': 'd',
          'data-activity-type': activityName,
          'data-total-cents': totalCents,
          'data-organization': organizationName,
          'data-user-id': currentUserId,
          'data-program-id': dropInId,
          'data-vp-added': addedVoloPass,
        }}
      >
        {updating ? updatingLabel : buttonLabel}
      </Button>
    </div>
  );
};

SubmitButton.propTypes = {
  buttonDisabled: PropTypes.bool,
  buttonAction: PropTypes.func,
  buttonLabel: PropTypes.string,
  updatingLabel: PropTypes.string,
  updating: PropTypes.bool,
  dropInId: PropTypes.string,
  totalCents: PropTypes.number,
  activityName: PropTypes.string,
  dropInId: PropTypes.string,
  currentUserId: PropTypes.string,
  organizationName: PropTypes.string,
  addedVoloPass: PropTypes.bool,
};

SubmitButton.defaultProps = {
  buttonAction: undefined,
  buttonDisabled: true,
  buttonLabel: 'Submit',
  updatingLabel: 'Waiting...',
  updating: false,
};

export default SubmitButton;
